import { render, staticRenderFns } from "./MethodPage.vue?vue&type=template&id=6211510e&"
import script from "./MethodPage.vue?vue&type=script&lang=js&"
export * from "./MethodPage.vue?vue&type=script&lang=js&"
import style0 from "./MethodPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports